'use server'

import { getServerSession } from 'next-auth'

import db from '@/lib/db'
import { SetupFormData } from './types'
import { authOptions } from '../auth/server'
import { embedGitHubRepository } from '../embedding'

export const createProject = async ({
  name,
  repoUrl,
  aiProvider,
  ollamaEndpointUrl,
  openaiApiKey,
  ramSizeGb,
  userId,
  devBranch
}: SetupFormData & { userId: string }) =>
  await db?.project.create({
    data: {
      name,
      users: { connect: { id: userId } },
      repoUrl,
      aiProvider,
      ollamaEndpointUrl,
      openaiApiKey,
      ramSizeGb: parseInt(ramSizeGb as string),
      threads: {
        create: {
          users: { connect: { id: userId } }
        }
      },
      devBranch
    },
    include: { threads: true }
  })

export async function initProject(values: SetupFormData) {
  const session = await getServerSession(authOptions)
  const token = session?.user?.accounts[0].access_token
  if (!session || !token) throw new Error('Unauthorized')

  const project = await createProject({
    ...values,
    userId: session.user.id
  }).catch(error => {
    console.error('Error creating project', error)
    throw new Error('Failed to create project:', error.message)
  })

  embedGitHubRepository(values, token).catch(error => {
    console.error('Failed to embed repository:', error.message)
  })

  return project
}
